/**
 * ScopeChipNode - a read-only inline ATOM chip for structured values rendered inside the deal
 * Scope doc (status / work-type / hours chips, enum answers, scope-brief tags). An atom keeps
 * the value un-editable as text (it deletes as one unit), so the harvest never has to parse a
 * half-edited enum back into an option value. The label is carried in attrs and rendered as
 * plain text, so copy/paste and renderText degrade to the label string.
 */
import { mergeAttributes, Node } from '@tiptap/core';
export const ScopeChipNode = Node.create({
    name: 'scopeChip',
    group: 'inline',
    inline: true,
    atom: true,
    selectable: true,
    addAttributes() {
        return {
            label: {
                default: '',
                parseHTML: (el) => el.getAttribute('data-label') ?? el.textContent ?? '',
            },
            variant: {
                default: 'neutral',
                parseHTML: (el) => el.getAttribute('data-variant') ?? 'neutral',
            },
        };
    },
    parseHTML() {
        return [{ tag: 'span[data-scope-chip]' }];
    },
    renderHTML({ node, HTMLAttributes }) {
        const label = String(node.attrs.label ?? '');
        const variant = String(node.attrs.variant ?? 'neutral');
        return [
            'span',
            mergeAttributes(HTMLAttributes, {
                'data-scope-chip': '',
                'data-label': label,
                'data-variant': variant,
                class: `rte-scope-chip rte-scope-chip--${variant}`,
                contenteditable: 'false',
            }),
            label,
        ];
    },
    renderText({ node }) {
        return String(node.attrs.label ?? '');
    },
});
//# sourceMappingURL=scopeChipNode.js.map